import axios from 'axios';
import { handleResponse } from '../helpers/handleResponse';
import { authHeader } from './authHeader';

// update variants' delivery estimates
function updateDeliveryEstimate(reqBody: any){
    return axios({
        method: 'post',
        url: '/api/delivery-estimate',
        data: reqBody,
        headers: authHeader()
    }).then(handleResponse);
}

// get delivery estimate setttings
function getDeliveryEstimateSettings(){
  return axios({
      method: 'get',
      url: '/api/delivery-estimate/settings',
      headers: authHeader()
  }).then(handleResponse);
}

// update delivery estimate setttings
function updateDeliveryEstimateSettings(reqBody: any){
  return axios({
      method: 'post',
      url: '/api/delivery-estimate/settings',
      data: reqBody,
      headers: authHeader()
  }).then(handleResponse);
}

// get delivery estimates for a product group
function getDeliveryEstimateForPG(handle: string){
  return axios({
      method: 'get',
      url: '/api/delivery-estimate/product/' + handle,
      headers: authHeader()
  }).then(handleResponse);
}

// get delivery estimates for a product group
function updateDeliveryEstimateForVariant(handle: string, reqBody: any){
  return axios({
      method: 'post',
      url: '/api/delivery-estimate/product/' + handle,
      data: reqBody,
      headers: authHeader()
  }).then(handleResponse);
}

export {
  updateDeliveryEstimate,
  getDeliveryEstimateSettings,
  updateDeliveryEstimateSettings,
  getDeliveryEstimateForPG,
  updateDeliveryEstimateForVariant
};
